const updateAssetUploadId = (state, { payload: { uploadId } }) => {
	state.uploadId = uploadId;
};

export default updateAssetUploadId;
